var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { v4 as uuidv4 } from "uuid";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { getInitialTubeDiameterIndex } from "./scene/helpers";
import { getAllSelections, getSelectionAssignments, isCentralizedSystem, } from "./system-data/helpers";
import { GripPositionMarkerId, NodeComponentType, PatternTransform, tubeDiameterOptions, TubeType, UnitSystem, } from "store/types";
import * as sceneReducer from "store/scene/reducer";
import * as systemDataReducerDefineParameters from "store/system-data/define-parameters/reducer";
import * as systemDataReducerSelectApplication from "store/system-data/select-application/reducer";
import * as uiReducer from "store/ui/reducer";
import * as systemPerformanceReducer from "store/system-performance/reducer";
import * as userReducer from "store/user/reducer";
import * as undoSnapshotsReducer from "store/undo-snapshots/reducer";
import { getCommittedSelectionIds, getNodeSelectionSnapshot, nodeHasAnySelection, } from "store/undo-snapshots/helpers";
import { feedPressurePointNodeId, feedPressurePointPlaceholderName, } from "3d/constants/common";
import { defaultCupGap } from "3d/cup-grid-fill";
import { persistConfig as uiPersistConfig } from "store/ui/persist-config";
import { getPairsToConnect } from "store/auto-routing";
import { DEFAULT_LAYER } from "store/layers";
import { palletLayoutKind } from "store/scene/pallet-layout";
import { selectAttachments, selectCentralizedPumps, selectEdges, selectFeedPressurePoints, selectGripPositions, selectTubeConnections, } from "store/scene/selectors";
import { selectCupComponentsByNode } from "store/system-data/define-parameters/selectors";
import { selectors } from "store/selectors";
import { isMultipleBoxesFeatureAvailable } from "utility/feature-availability";
import { clearPersistedStorage, persist, persistTemplate, rehydrate, } from "store/persist";
var toggleGraphPanel = function (open) {
    return function (dispatch) {
        dispatch(uiReducer.internalActions.toggleGraphPanel(open));
    };
};
var checklistActionAddPump = function () { return function (dispatch, getState) {
    var state = getState();
    var systemDataDefineParameters = state.systemDataDefineParameters;
    var systemData = systemDataDefineParameters.dataState.data;
    if (!systemData)
        return;
    var isSystemCentralized = isCentralizedSystem(systemData);
    if (isSystemCentralized) {
        /* A pump added earlier but never picked is still waiting for the user;
         * bring them back to it rather than adding a second placeholder. */
        var placeholder = selectors.selectCentralPumpNodesWithoutPump(state)[0];
        if (placeholder) {
            dispatch(uiReducer.callableActions.selectEntity(placeholder.id));
        }
        else {
            dispatch(addCentralizedPump());
        }
    }
    else {
        dispatch(_selectGripPositionWithoutPumpSelection());
    }
}; };
var checklistActionAddTubeConnection = function () { return function (dispatch, getState) {
    /* As with "Add pump": bring the user back to a tube connection still
     * waiting for its type rather than adding a second placeholder. */
    var placeholder = selectors.selectTubeConnectionPlaceholders(getState())[0];
    if (placeholder) {
        dispatch(uiReducer.callableActions.selectEntity(placeholder.id));
    }
    else {
        dispatch(addTubeConnection());
    }
}; };
var checklistActionSelectCup = function () { return function (dispatch) {
    dispatch(_selectGripPositionWithoutCupSelection());
}; };
var _selectGripPositionWithoutPumpSelection = function () { return function (dispatch) {
    dispatch(_selectGripPositionWithoutSelectedComponent("vacuumPumpSelectionsDecentralized", "pumpSelectionDecentralMap"));
}; };
var _selectGripPositionWithoutCupSelection = function () { return function (dispatch) {
    dispatch(_selectGripPositionWithoutSelectedComponent("suctionCupSelections", "cupSelectionMap"));
}; };
var _selectGripPositionWithoutSelectedComponent = function (systemDataKey, defineParametersKey) {
    return function (dispatch, getState) {
        var e_1, _a;
        var state = getState();
        var systemDataDefineParameters = state.systemDataDefineParameters;
        var systemData = systemDataDefineParameters.dataState.data;
        if (!systemData)
            return;
        var sceneState = state.scene.present;
        var nodes = sceneState.nodes;
        var selections = systemData[systemDataKey];
        var selectionMap = systemDataDefineParameters[defineParametersKey];
        var gripPositionWithNoSelectionId;
        try {
            for (var _b = __values(Object.values(nodes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var node = _c.value;
                var isGripPosition = node.type === NodeComponentType.GRIP_POSITION;
                if (!isGripPosition)
                    continue;
                var nodeId = node.id;
                var selectionId = selectionMap[nodeId];
                var selectedComponent = selectionId && selections[selectionId];
                if (selectedComponent)
                    continue;
                gripPositionWithNoSelectionId = nodeId;
                break;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (gripPositionWithNoSelectionId) {
            dispatch(uiReducer.callableActions.selectEntity(gripPositionWithNoSelectionId));
        }
    };
};
/*
 * Reserves the Tacton selection slots a grip position needs — cup, mounting,
 * decentral pump, and cup technology where the application has any. All or
 * nothing: if any slot is unavailable the ones already taken are given back
 * and the node must not be created.
 */
var reserveGripPositionSelections = function (nodeId) {
    return function (dispatch, getState) {
        var _a;
        var assign = systemDataReducerDefineParameters.internalActions;
        dispatch(assign.assignCupSelection(nodeId));
        dispatch(assign.assignCupMountingSelection(nodeId));
        dispatch(assign.assignDecentralPumpSelection(nodeId));
        var hasCupTechnologies = Object.keys(((_a = getState().systemDataDefineParameters.dataState.data) === null || _a === void 0 ? void 0 : _a.cupTechnologySelections) || {}).length > 0;
        if (hasCupTechnologies) {
            dispatch(assign.assignCupTechnologySelection(nodeId));
        }
        var systemDataDefineParameters = getState().systemDataDefineParameters;
        if (!systemDataDefineParameters.cupSelectionMap[nodeId] ||
            !systemDataDefineParameters.cupMountingSelectionMap[nodeId] ||
            (hasCupTechnologies &&
                !systemDataDefineParameters.cupTechnologySelectionMap[nodeId]) ||
            !systemDataDefineParameters.pumpSelectionDecentralMap[nodeId]) {
            dispatch(assign.unassignAllSelections([nodeId]));
            return false;
        }
        return true;
    };
};
/* Adds a grip position with its selection slots reserved and no cup picked: a
 * placeholder in the scene, as "Add pump" adds an unpicked pump. Placing more
 * of the same cup is what the grip position's duplicate button is for. */
var addGripPosition = function () { return function (dispatch) {
    var nodeId = "grip-position-".concat(uuidv4());
    if (!dispatch(reserveGripPositionSelections(nodeId)))
        return;
    dispatch(sceneReducer.internalActions.addGripPosition(nodeId));
    dispatch(uiReducer.callableActions.selectEntity(nodeId));
}; };
/*
 * Adds a central pump node with a reserved Tacton slot but no pump picked: a
 * placeholder in the scene (see `selectCentralPumpNodesWithoutPump`). The user
 * chooses the actual pump from the node's picker, which is opened by selecting
 * the new node here. No default is committed on their behalf.
 */
var addCentralizedPump = function () { return function (dispatch, getState) {
    if (getState().systemDataDefineParameters.dataState.isLoading)
        return;
    var nodeId = "central-pump-".concat(uuidv4());
    dispatch(systemDataReducerDefineParameters.internalActions.assignCentralPumpSelection(nodeId));
    if (!getState().systemDataDefineParameters.pumpSelectionCentralMap[nodeId]) {
        return;
    }
    dispatch(sceneReducer.internalActions.addCentralizedPump(nodeId));
    dispatch(uiReducer.callableActions.selectEntity(nodeId));
}; };
/*
 * Adds a tube connection with no connection type picked: a placeholder in the
 * scene, as "Add pump" adds an unpicked pump. The user picks the type from the
 * connection type drawer, which selecting the new node opens.
 */
var addTubeConnection = function () { return function (dispatch) {
    var nodeId = "tube-connection-".concat(uuidv4());
    dispatch(sceneReducer.internalActions.addTubeConnection(nodeId));
    dispatch(uiReducer.callableActions.selectEntity(nodeId));
    return nodeId;
}; };
var addEdge = function (fromAttachmentId, toAttachmentId) {
    return function (dispatch) {
        dispatch(addEdges([{ fromAttachmentId: fromAttachmentId, toAttachmentId: toAttachmentId }]));
    };
};
var addEdges = function (attachments) {
    return function (dispatch, getState) {
        var e_2, _a;
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        var systemDataDefineParameters = getState().systemDataDefineParameters.dataState.data;
        if (!systemDataDefineParameters)
            return;
        var unitSystem = getState().ui.unitSystem;
        var initialTubeDiameterIndex = getInitialTubeDiameterIndex(unitSystem, systemDataDefineParameters);
        var edgeId;
        var newEdges = [];
        try {
            for (var attachments_1 = __values(attachments), attachments_1_1 = attachments_1.next(); !attachments_1_1.done; attachments_1_1 = attachments_1.next()) {
                var attachment = attachments_1_1.value;
                var fromAttachmentId = attachment.fromAttachmentId, toAttachmentId = attachment.toAttachmentId;
                edgeId = "edge-".concat(uuidv4());
                newEdges.push({
                    fromAttachmentId: fromAttachmentId,
                    toAttachmentId: toAttachmentId,
                    edgeId: edgeId,
                    unitSystem: unitSystem,
                    initialTubeDiameterIndex: initialTubeDiameterIndex,
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (attachments_1_1 && !attachments_1_1.done && (_a = attachments_1.return)) _a.call(attachments_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        dispatch(sceneReducer.internalActions.addEdges(newEdges));
        dispatch(uiReducer.callableActions.selectEntity(edgeId));
    };
};
var setUnitSystem = function (unitSystem) {
    return function (dispatch, getState) {
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        var systemDataDefineParameters = getState().systemDataDefineParameters.dataState.data;
        if (!systemDataDefineParameters)
            return;
        var edges = getState().scene.present.edges;
        var edgeIds = Object.keys(edges);
        var initialTubeDiameterIndex = getInitialTubeDiameterIndex(unitSystem, systemDataDefineParameters);
        var defaultDiameter = tubeDiameterOptions[unitSystem][initialTubeDiameterIndex].value;
        dispatch(sceneReducer.callableActions.setEdgeDiameterDefaultTube({
            edgeIds: edgeIds,
            diameter: defaultDiameter,
            index: initialTubeDiameterIndex,
        }));
        dispatch(sceneReducer.callableActions.setEdgeDiameterBlowOffTube({
            edgeIds: edgeIds,
            diameter: defaultDiameter,
            index: initialTubeDiameterIndex,
        }));
        dispatch(uiReducer.callableActions.setUnitSystem(unitSystem));
    };
};
var duplicateNode = function (nodeId) {
    return function (dispatch, getState) {
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        var newNodeId = "tube-connection-".concat(uuidv4());
        var sceneState = getState().scene.present;
        if (sceneState.nodes[nodeId].type === NodeComponentType.GRIP_POSITION) {
            newNodeId = "grip-position-".concat(uuidv4());
            if (!dispatch(reserveGripPositionSelections(newNodeId)))
                return;
            dispatch(systemDataReducerDefineParameters.internalActions.duplicateSelections({
                fromNodeId: nodeId,
                toNodeIds: [newNodeId],
            }));
        }
        else if (sceneState.nodes[nodeId].type ===
            NodeComponentType.CENTRALIZED_VACUUM_PUMP) {
            newNodeId = "central-pump-".concat(uuidv4());
            dispatch(systemDataReducerDefineParameters.internalActions.assignCentralPumpSelection(newNodeId));
            if (!getState().systemDataDefineParameters.pumpSelectionCentralMap[newNodeId]) {
                return;
            }
            dispatch(systemDataReducerDefineParameters.internalActions.duplicateSelections({
                fromNodeId: nodeId,
                toNodeIds: [newNodeId],
            }));
        }
        dispatch(sceneReducer.internalActions.duplicateNode({
            fromNodeId: nodeId,
            toNodeId: newNodeId,
        }));
        dispatch(uiReducer.callableActions.selectEntity(newNodeId));
    };
};
/*
 * Arm or disarm the "fill an area with cups" tool on a grip position. Armed,
 * the picker turns the next click in the scene into a grid of copies of this
 * cup (see `fillAreaWithGripPositions`); the gap between the copies starts at
 * one cup-width and is adjustable while the tool is armed.
 */
var toggleCupFill = function (anchorNodeId) {
    return function (dispatch, getState) {
        var _a;
        var state = getState();
        if (((_a = state.ui.cupFill) === null || _a === void 0 ? void 0 : _a.anchorNodeId) === anchorNodeId) {
            dispatch(uiReducer.callableActions.stopCupFill());
            return;
        }
        var anchor = state.scene.present.nodes[anchorNodeId];
        if (!anchor || anchor.type !== NodeComponentType.GRIP_POSITION)
            return;
        var cupComponent = selectCupComponentsByNode(state)[anchorNodeId];
        var marker = anchor.component;
        var gap = defaultCupGap({
            center: { x: anchor.position.x, z: anchor.position.z },
            width: (cupComponent === null || cupComponent === void 0 ? void 0 : cupComponent.width) || marker.width,
            depth: (cupComponent === null || cupComponent === void 0 ? void 0 : cupComponent.height) || marker.height || marker.width,
            rotationY: anchor.rotationY,
        });
        dispatch(uiReducer.callableActions.startCupFill({ anchorNodeId: anchorNodeId, gap: gap }));
    };
};
/*
 * Create copies of a grip position at the given places — the fill tool's
 * commit. Like `duplicateNode` for each copy, but batched where it matters:
 * every copy's Tacton slots are reserved up front (stopping at the first one
 * that cannot be, so a fill never half-succeeds silently — the preview already
 * caps the grid at what is available), the anchor's component selections go
 * to Tacton in ONE request, and the scene gets ONE undoable action. The tool
 * disarms whatever happens; the anchor stays selected.
 */
var fillAreaWithGripPositions = function (anchorNodeId, positions) {
    return function (dispatch, getState) {
        var e_3, _a;
        dispatch(uiReducer.callableActions.stopCupFill());
        var state = getState();
        if (state.systemDataDefineParameters.dataState.isLoading)
            return;
        var anchor = state.scene.present.nodes[anchorNodeId];
        if (!anchor || anchor.type !== NodeComponentType.GRIP_POSITION)
            return;
        var copies = [];
        try {
            for (var positions_1 = __values(positions), positions_1_1 = positions_1.next(); !positions_1_1.done; positions_1_1 = positions_1.next()) {
                var position = positions_1_1.value;
                var toNodeId = "grip-position-".concat(uuidv4());
                if (!dispatch(reserveGripPositionSelections(toNodeId)))
                    break;
                copies.push({ toNodeId: toNodeId, position: position });
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (positions_1_1 && !positions_1_1.done && (_a = positions_1.return)) _a.call(positions_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (copies.length === 0)
            return;
        dispatch(systemDataReducerDefineParameters.internalActions.duplicateSelections({
            fromNodeId: anchorNodeId,
            toNodeIds: copies.map(function (_a) {
                var toNodeId = _a.toNodeId;
                return toNodeId;
            }),
        }));
        dispatch(sceneReducer.internalActions.duplicateNodeToPositions({
            fromNodeId: anchorNodeId,
            copies: copies,
        }));
    };
};
/* Deletes nodes and edges, the nodes together with their Tacton selections,
 * in one request and as one undo step. The feed pressure point is never
 * deleted. */
var deleteEntities = function (_a) {
    var requestedNodeIds = _a.nodeIds, _b = _a.edgeIds, edgeIds = _b === void 0 ? [] : _b;
    return function (dispatch, getState) {
        var e_4, _a;
        var sceneNodes = getState().scene.present.nodes;
        var nodeIds = requestedNodeIds.filter(function (nodeId) { var _a; return ((_a = sceneNodes[nodeId]) === null || _a === void 0 ? void 0 : _a.type) !== NodeComponentType.FEED_PRESSURE_POINT; });
        if (nodeIds.length === 0 && edgeIds.length === 0)
            return;
        if (nodeIds.length > 0) {
            var systemData = getState().systemDataDefineParameters;
            if (systemData.dataState.isLoading)
                return;
            try {
                /* Capture the selection slots and values for each node before we clear
                 * them, so a later undo can restore them. These only live in
                 * Tacton/systemData and cannot be recovered from the scene graph that
                 * redux-undo restores. */
                for (var nodeIds_1 = __values(nodeIds), nodeIds_1_1 = nodeIds_1.next(); !nodeIds_1_1.done; nodeIds_1_1 = nodeIds_1.next()) {
                    var nodeId = nodeIds_1_1.value;
                    dispatch(undoSnapshotsReducer.callableActions.storeSnapshot({
                        nodeId: nodeId,
                        snapshot: getNodeSelectionSnapshot(systemData, nodeId),
                    }));
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (nodeIds_1_1 && !nodeIds_1_1.done && (_a = nodeIds_1.return)) _a.call(nodeIds_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            dispatch(systemDataReducerDefineParameters.internalActions.deselectAllComponents(nodeIds));
            dispatch(systemDataReducerDefineParameters.internalActions.unassignAllSelections(nodeIds));
        }
        /* An internalAction, so the delete is recorded in the redux-undo history;
         * undo/redo of it is orchestrated by the undo/redo thunks below, which
         * keep Tacton in sync with the scene. */
        dispatch(sceneReducer.internalActions.deleteEntities({ nodeIds: nodeIds, edgeIds: edgeIds }));
        dispatch(uiReducer.callableActions.deselectEntities());
    };
};
var deleteNodes = function (nodeIds) {
    return deleteEntities({ nodeIds: nodeIds });
};
var deleteNode = function (nodeId) { return deleteNodes([nodeId]); };
/* Gives nodes that come back into the scene (an undo of their delete, a redo
 * of their add) their selection slots and committed values again, from the
 * snapshots taken when they left. Reserves the slots, then commits all values
 * in a single request. Returns false (and rolls back the reservations) if the
 * slots can't be reserved or Tacton rejects the commit, so the caller can
 * abort without ever touching the scene. */
var restoreNodeSelections = function (nodeIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var assign, snapshots, rollback, parameters, values, nodeIds_2, nodeIds_2_1, nodeId, snapshot, systemData, entries, entries_1, entries_1_1, _a, selectionId, value, _b;
        var e_5, _c, e_6, _d;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    assign = systemDataReducerDefineParameters.internalActions;
                    snapshots = getState().undoSnapshots.nodeSelections;
                    rollback = function () { return dispatch(assign.unassignAllSelections(nodeIds)); };
                    parameters = [];
                    values = [];
                    try {
                        for (nodeIds_2 = __values(nodeIds), nodeIds_2_1 = nodeIds_2.next(); !nodeIds_2_1.done; nodeIds_2_1 = nodeIds_2.next()) {
                            nodeId = nodeIds_2_1.value;
                            snapshot = (_e = snapshots[nodeId]) !== null && _e !== void 0 ? _e : {};
                            if (snapshot.cup !== undefined)
                                dispatch(assign.assignCupSelection(nodeId));
                            if (snapshot.cupMounting !== undefined)
                                dispatch(assign.assignCupMountingSelection(nodeId));
                            if (snapshot.cupTechnology !== undefined)
                                dispatch(assign.assignCupTechnologySelection(nodeId));
                            if (snapshot.pumpCentral !== undefined)
                                dispatch(assign.assignCentralPumpSelection(nodeId));
                            if (snapshot.pumpDecentral !== undefined)
                                dispatch(assign.assignDecentralPumpSelection(nodeId));
                            systemData = getState().systemDataDefineParameters;
                            entries = [
                                {
                                    selectionId: systemData.cupSelectionMap[nodeId],
                                    value: snapshot.cup,
                                },
                                {
                                    selectionId: systemData.cupMountingSelectionMap[nodeId],
                                    value: snapshot.cupMounting,
                                },
                                {
                                    selectionId: systemData.cupTechnologySelectionMap[nodeId],
                                    value: snapshot.cupTechnology,
                                },
                                {
                                    selectionId: systemData.pumpSelectionCentralMap[nodeId],
                                    value: snapshot.pumpCentral,
                                },
                                {
                                    selectionId: systemData.pumpSelectionDecentralMap[nodeId],
                                    value: snapshot.pumpDecentral,
                                },
                            ];
                            try {
                                for (entries_1 = (e_6 = void 0, __values(entries)), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                                    _a = entries_1_1.value, selectionId = _a.selectionId, value = _a.value;
                                    if (value === undefined)
                                        continue;
                                    /* A snapshot slot with no free selection slot to hold it means we
                                     * cannot faithfully restore the node — abort rather than restore a
                                     * partial state. */
                                    if (!selectionId) {
                                        rollback();
                                        return [2 /*return*/, false];
                                    }
                                    if (value === null)
                                        continue;
                                    parameters.push(selectionId);
                                    values.push(value);
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (entries_1_1 && !entries_1_1.done && (_d = entries_1.return)) _d.call(entries_1);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (nodeIds_2_1 && !nodeIds_2_1.done && (_c = nodeIds_2.return)) _c.call(nodeIds_2);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    if (parameters.length === 0)
                        return [2 /*return*/, true];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(systemDataReducerDefineParameters.callableActions.setParametersDefineParameters({ parameters: parameters, values: values })).unwrap()];
                case 2:
                    _f.sent();
                    return [2 /*return*/, true];
                case 3:
                    _b = _f.sent();
                    rollback();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/* Clears the committed selections of nodes that leave the scene (a redo of
 * their delete, an undo of their add) from Tacton in a single request and
 * frees their selection slots. Snapshots them first so they can be restored
 * if the nodes come back. Returns false if Tacton rejects the clear, in which
 * case the nodes get their slots back and the caller can abort. */
var clearNodeSelections = function (nodeIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var systemDataActions, systemData, idsToClear, _a, nodeIds_3, nodeIds_3_1, nodeId;
        var e_7, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    systemDataActions = systemDataReducerDefineParameters.internalActions;
                    systemData = getState().systemDataDefineParameters;
                    idsToClear = nodeIds.flatMap(function (nodeId) {
                        return getCommittedSelectionIds(systemData, nodeId);
                    });
                    /* Free the slots before the clear lands: the nodes are still in the
                     * scene until the caller moves on, and whatever reacts to an emptied
                     * slot on a node (e.g. the observer that gives the latest added grip
                     * position the latest picked cup) would commit the pick right back. */
                    dispatch(systemDataActions.unassignAllSelections(nodeIds));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    if (!(idsToClear.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(systemDataReducerDefineParameters.callableActions.clearParameters(idsToClear)).unwrap()];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _a = _c.sent();
                    /* Tacton still holds the picks, so the scene and Tacton remain in
                     * sync once the slots are back; let the caller abort. */
                    dispatch(systemDataActions.assignSelections(getSelectionAssignments(systemData, nodeIds)));
                    return [2 /*return*/, false];
                case 5:
                    try {
                        for (nodeIds_3 = __values(nodeIds), nodeIds_3_1 = nodeIds_3.next(); !nodeIds_3_1.done; nodeIds_3_1 = nodeIds_3.next()) {
                            nodeId = nodeIds_3_1.value;
                            dispatch(undoSnapshotsReducer.callableActions.storeSnapshot({
                                nodeId: nodeId,
                                snapshot: getNodeSelectionSnapshot(systemData, nodeId),
                            }));
                        }
                    }
                    catch (e_7_1) { e_7 = { error: e_7_1 }; }
                    finally {
                        try {
                            if (nodeIds_3_1 && !nodeIds_3_1.done && (_b = nodeIds_3.return)) _b.call(nodeIds_3);
                        }
                        finally { if (e_7) throw e_7.error; }
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
};
/* Brings Tacton in line with the scene that undo/redo is about to restore:
 * nodes that leave have their selections cleared, nodes that come back have
 * theirs restored. Clears first, which also frees slots for the restore. If
 * the restore fails, the cleared nodes get their selections back (they stay
 * in the scene) and the caller must leave the scene untouched. */
var syncSelectionsWithScene = function (from, to) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, leaving, returning, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = getState();
                    leaving = Object.keys(from.nodes).filter(function (nodeId) {
                        return !to.nodes[nodeId] &&
                            nodeHasAnySelection(state.systemDataDefineParameters, nodeId);
                    });
                    returning = Object.keys(to.nodes).filter(function (nodeId) {
                        return !from.nodes[nodeId] && state.undoSnapshots.nodeSelections[nodeId];
                    });
                    _a = leaving.length > 0;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(clearNodeSelections(leaving))];
                case 1:
                    _a = !(_c.sent());
                    _c.label = 2;
                case 2:
                    if (_a)
                        return [2 /*return*/, false];
                    _b = returning.length > 0;
                    if (!_b) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(restoreNodeSelections(returning))];
                case 3:
                    _b = !(_c.sent());
                    _c.label = 4;
                case 4:
                    if (!_b) return [3 /*break*/, 7];
                    if (!(leaving.length > 0)) return [3 /*break*/, 6];
                    return [4 /*yield*/, dispatch(restoreNodeSelections(leaving))];
                case 5:
                    _c.sent();
                    _c.label = 6;
                case 6: return [2 /*return*/, false];
                case 7: return [2 /*return*/, true];
            }
        });
    }); };
};
/* Undo/redo that keep Tacton in sync with the scene graph. Tacton is updated
 * first; only if that succeeds do we move through the scene history, so the
 * graph and Tacton never drift out of sync. */
var stepSceneHistory = function (direction) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, _a, past, present, future, target;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    if (state.systemDataDefineParameters.dataState.isLoading)
                        return [2 /*return*/];
                    _a = state.scene, past = _a.past, present = _a.present, future = _a.future;
                    target = direction === "undo" ? past[past.length - 1] : future[0];
                    if (!target)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(syncSelectionsWithScene(present, target))];
                case 1:
                    if (!(_b.sent()))
                        return [2 /*return*/];
                    if (Object.keys(present.nodes).some(function (nodeId) { return !target.nodes[nodeId]; })) {
                        dispatch(uiReducer.callableActions.deselectEntities());
                    }
                    dispatch(direction === "undo"
                        ? UndoActionCreators.undo()
                        : UndoActionCreators.redo());
                    return [2 /*return*/];
            }
        });
    }); };
};
var undo = function () { return stepSceneHistory("undo"); };
var redo = function () { return stepSceneHistory("redo"); };
/*
    This action resets all values to Tacton defaults (for example when switching application) by either uncommiting the fields or commit the default
    value for them.

    Parameters in Tacton that are marked as "always committed" are parameters that cannot be uncommited, so instead Piab has added the default value for
    these parameters so that we can instead restore them to that value.
    
    Parameters that are "committed" are parameters that the user has changed/commited, so we need to uncommit these parameters to reset.
*/
var resetParametersToDefault = createAsyncThunk("reset-parameters", function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, getState, data, parameters, parameterIdsToClear, selections, selectionIdsToClear, parameterToSetToDefault, idsToClear;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                dispatch = thunkAPI.dispatch, getState = thunkAPI.getState;
                data = (_a = getState().systemDataDefineParameters) === null || _a === void 0 ? void 0 : _a.dataState.data;
                parameters = data === null || data === void 0 ? void 0 : data.parameters;
                parameterIdsToClear = parameters
                    ? Object.values(parameters)
                        .filter(function (parameter) { return !parameter.alwaysCommitted; })
                        .filter(function (parameter) { return parameter.committed; })
                        .map(function (parameter) { return parameter.id; })
                    : [];
                selections = data ? getAllSelections(data) : {};
                selectionIdsToClear = Object.keys(selections).filter(function (selectionId) { return selections[selectionId]; });
                parameterToSetToDefault = parameters
                    ? Object.values(parameters).filter(function (parameter) { return parameter.alwaysCommitted && parameter.ovmDefaultValue; })
                    : [];
                idsToClear = __spreadArray(__spreadArray([], __read(parameterIdsToClear), false), __read(selectionIdsToClear), false);
                if (!(idsToClear.length > 0)) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(systemDataReducerDefineParameters.callableActions.clearParameters(idsToClear))];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [4 /*yield*/, dispatch(actions.setParametersDefineParameters({
                    parameters: parameterToSetToDefault.map(function (parameter) { return parameter.id; }),
                    values: parameterToSetToDefault.map(function (parameter) { return parameter.ovmDefaultValue; }),
                }))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); });
var resetScene = function () { return function (dispatch, getState) {
    var nodeIds = Object.keys(getState().scene.present.nodes);
    if (nodeIds.length > 1) {
        // Clear every component selection (values + maps), not just the per-node
        // mappings. Leaving stale selection values behind kept checklist items
        // (e.g. "Add pump") marked as done on the new empty system.
        dispatch(systemDataReducerDefineParameters.internalActions.clearAllSelections());
        dispatch(sceneReducer.callableActions.clearScene());
        dispatch(uiReducer.callableActions.deselectEntities());
    }
    // restoring attachment points for Feed pressure point
    dispatch(actions.setNodeAttachments({
        nodeId: feedPressurePointNodeId,
        placeholders: [
            {
                name: feedPressurePointPlaceholderName,
                tubeType: TubeType.COMPRESSED_AIR,
            },
        ],
    }));
}; };
var rehydrateSystemState = createAsyncThunk("rehydrate-system", function (_a, thunkAPI) {
    var persistor = _a.persistor;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    thunkAPI.dispatch(resetScene());
                    clearPersistedStorage();
                    persistor();
                    return [4 /*yield*/, rehydrate(thunkAPI)];
                case 1:
                    _b.sent();
                    /* A system saved where the pallet feature is offered may arrive where it is
                     * not: it then collapses to its single box, so nothing of the feature shows
                     * (the switch is scene state, so the migration alone can't do this). */
                    if (!isMultipleBoxesFeatureAvailable() &&
                        selectors.selectMultipleBoxesEnabled(thunkAPI.getState())) {
                        thunkAPI.dispatch(setMultipleBoxesEnabled(false));
                    }
                    return [2 /*return*/];
            }
        });
    });
});
var loadTemplateSystem = createAsyncThunk("load-template", function (_a, thunkAPI) {
    var templateData = _a.templateData;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, thunkAPI.dispatch(rehydrateSystemState({
                        persistor: function () { return persistTemplate(templateData); },
                    }))];
                case 1:
                    _b.sent();
                    // Loading a template starts a fresh, unsaved system. Clear any active
                    // saved system so a subsequent save creates a new system instead of
                    // overwriting the previously loaded one.
                    thunkAPI.dispatch(userReducer.callableActions.setUserActiveSystem(undefined));
                    /* There is a problem for templates that do not define which metric system they are defined in.
                        
                        If we are using imperial units locally when loading a template defined in metric units,
                        then the tube diameters indices in the template code will point to the wrong
                        places in our tube diameter options array.
                        
                        The below will default these templates to metric so that we at least don't get any problems for templates defined in metric. */
                    if (!templateData.includes("".concat(uiPersistConfig.key, "="))) {
                        thunkAPI.dispatch(uiReducer.callableActions.setUnitSystem(UnitSystem.METRIC));
                    }
                    return [2 /*return*/];
            }
        });
    });
});
var setParametersSelectApplication = createAsyncThunk("set-parameters-select-application", function (parameters, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, thunkAPI.dispatch(systemDataReducerSelectApplication.callableActions.setSelectApplicationParameters(parameters))];
            case 1:
                _a.sent();
                return [4 /*yield*/, thunkAPI.dispatch(systemDataReducerDefineParameters.callableActions.getSystemDataDefineParameters())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
var loadSystemState = function (system) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var pendingSystemState;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(userReducer.callableActions.fetchSystemState({ systemId: system.id }))];
                case 1:
                    _a.sent();
                    pendingSystemState = getState().user.pendingSystemState;
                    if (!pendingSystemState) {
                        return [2 /*return*/, Promise.resolve(false)];
                    }
                    return [4 /*yield*/, dispatch(rehydrateSystemState({
                            persistor: function () {
                                return pendingSystemState.forEach(function (part) {
                                    return persist(part.persistKey, part.data);
                                });
                            },
                        }))];
                case 2:
                    _a.sent();
                    dispatch(userReducer.callableActions.setUserActiveSystem(system));
                    return [2 /*return*/, Promise.resolve(true)];
            }
        });
    }); };
};
var deleteEdge = function (edgeId) {
    return function (dispatch) {
        dispatch(sceneReducer.internalActions.deleteEdge(edgeId));
        dispatch(uiReducer.callableActions.deselectEntities());
    };
};
var selectCup = function (_a) {
    var nodeIds = _a.nodeIds, value = _a.value;
    return function (dispatch, getState) {
        var e_8, _a;
        var _b, _c;
        dispatch(systemDataReducerDefineParameters.internalActions.selectCup({
            nodeIds: nodeIds,
            value: value,
        }));
        var cupData = (_b = getState().systemDataDefineParameters.dataState.data) === null || _b === void 0 ? void 0 : _b.suctionCupComponents[value];
        if (cupData) {
            // A cup counts as round when its two dimensions are within 5% of each
            // other; otherwise it is oblong. Compare short/long side so the check
            // is independent of cup orientation (landscape vs portrait).
            var cupIsRound = Math.min(cupData.width, cupData.height) /
                Math.max(cupData.width, cupData.height) >
                0.95;
            try {
                for (var nodeIds_4 = __values(nodeIds), nodeIds_4_1 = nodeIds_4.next(); !nodeIds_4_1.done; nodeIds_4_1 = nodeIds_4.next()) {
                    var nodeId = nodeIds_4_1.value;
                    var node = getState().scene.present.nodes[nodeId];
                    if (!node)
                        continue;
                    var isGripPosition = node.type === NodeComponentType.GRIP_POSITION;
                    var marker = isGripPosition
                        ? node.component.marker
                        : undefined;
                    // Keep the grip position's marker shape in sync with the cup:
                    // a round cup belongs in a circle marker (an oval marker sized to a
                    // round cup just renders as a degenerate oval), an oblong cup in an
                    // oval marker. Switching the marker must run before the width/height
                    // updates below, because it resets width/height to the marker defaults.
                    if (cupIsRound && marker === GripPositionMarkerId.OVAL) {
                        dispatch(sceneReducer.callableActions.setGripPositionMarker({
                            nodeId: nodeId,
                            marker: GripPositionMarkerId.CIRCLE,
                        }));
                    }
                    else if (!cupIsRound && marker === GripPositionMarkerId.CIRCLE) {
                        dispatch(sceneReducer.callableActions.setGripPositionMarker({
                            nodeId: nodeId,
                            marker: GripPositionMarkerId.OVAL,
                        }));
                    }
                    dispatch(sceneReducer.callableActions.setGripPositionWidth({
                        nodeId: nodeId,
                        width: cupData.width * 1.1,
                    }));
                    var currentMarker = ((_c = getState().scene.present.nodes[nodeId]) === null || _c === void 0 ? void 0 : _c.component).marker;
                    if (isGripPosition && currentMarker === GripPositionMarkerId.OVAL) {
                        dispatch(sceneReducer.callableActions.setGripPositionHeight({
                            nodeId: nodeId,
                            height: cupData.height * 1.1,
                        }));
                    }
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (nodeIds_4_1 && !nodeIds_4_1.done && (_a = nodeIds_4.return)) _a.call(nodeIds_4);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
    };
};
var performAutoRouting = function () { return function (dispatch, getState) {
    var state = getState();
    var systemDataDefineParameters = state.systemDataDefineParameters;
    var systemData = systemDataDefineParameters.dataState.data;
    var isSystemCentralized = isCentralizedSystem(systemData);
    var centralPumps = selectCentralizedPumps(state);
    var tubeConnections = selectTubeConnections(state);
    var gripPositions = selectGripPositions(state);
    var feedPressurePoints = selectFeedPressurePoints(state);
    // Ensure each grip position has a cup selection.
    var suctionCups = gripPositions.filter(function (gripPosition) {
        return systemData === null || systemData === void 0 ? void 0 : systemData.suctionCupSelections[systemDataDefineParameters.cupSelectionMap[gripPosition.id]];
    });
    var attachments = selectAttachments(state);
    var edges = selectEdges(state);
    if (isSystemCentralized) {
        var pairsToConnect = getPairsToConnect(feedPressurePoints, centralPumps, tubeConnections, Object.values(attachments), Object.values(edges), TubeType.COMPRESSED_AIR);
        dispatch(addEdges(pairsToConnect));
        var updatedState = getState();
        var updatedAttachments = selectAttachments(updatedState);
        var updatedEdges = selectEdges(updatedState);
        var updatedPairsToConnect = getPairsToConnect(centralPumps, suctionCups, tubeConnections, Object.values(updatedAttachments), Object.values(updatedEdges), TubeType.VACUUM);
        dispatch(addEdges(updatedPairsToConnect));
    }
    else {
        // Ensure each suction cup has a decentralized pump selection.
        var suctionCupsWithPumps = suctionCups.filter(function (node) {
            return systemData === null || systemData === void 0 ? void 0 : systemData.vacuumPumpSelectionsDecentralized[systemDataDefineParameters.pumpSelectionDecentralMap[node.id]];
        });
        var pairsToConnect = getPairsToConnect(feedPressurePoints, suctionCupsWithPumps, tubeConnections, Object.values(attachments), Object.values(edges), TubeType.COMPRESSED_AIR);
        dispatch(addEdges(pairsToConnect));
    }
}; };
// Add a cardboard box to the currently-active layer. Kept as a thunk (rather
// than dispatching the reducer directly) so the UI doesn't have to thread the
// active layer through; the reducer stays pure/undoable.
var addCardboardBox = function () { return function (dispatch, getState) {
    var layer = getState().ui.activeLayer;
    dispatch(sceneReducer.internalActions.addCardboardBox({ layer: layer }));
}; };
/*
 * Lay the currently-active row out in a palletizing pattern. A thunk for the
 * same reason as `addCardboardBox`: the UI shouldn't have to thread the active
 * row through, and the reducer stays pure and undoable.
 *
 * The preset list offers each pattern together with the transform (mirrored /
 * turned) that lands on the pallet, so both arrive here as one choice.
 */
var applyPalletPattern = function (patternId, transform) {
    if (transform === void 0) { transform = PatternTransform.NONE; }
    return function (dispatch, getState) {
        dispatch(sceneReducer.internalActions.applyPalletPattern({
            layer: getState().ui.activeLayer,
            patternId: patternId,
            transform: transform,
        }));
    };
};
/*
 * Bring the second stacking layer into use and switch the view to it. The
 * scene change is one undoable step (`addSecondLayer`); the view switch is not
 * undoable, matching how the layer switch itself behaves.
 */
var addSecondLayer = function () { return function (dispatch) {
    dispatch(sceneReducer.internalActions.addSecondLayer());
    dispatch(uiReducer.callableActions.setActiveLayer(1));
}; };
/* Take the second layer out of use and return the view to the first. */
var removeSecondLayer = function () { return function (dispatch) {
    dispatch(sceneReducer.internalActions.removeSecondLayer());
    dispatch(uiReducer.callableActions.setActiveLayer(DEFAULT_LAYER));
}; };
/*
 * Turn working with a pallet of boxes on or off. The scene change (one undoable
 * step — turning it off collapses the layout back to the single box) lives in
 * the reducer; this thunk also brings the non-undoable view state back with it:
 * the second layer no longer exists to look at, and a selected box would keep a
 * panel open for a feature that just went away.
 */
var setMultipleBoxesEnabled = function (enabled) {
    return function (dispatch) {
        dispatch(sceneReducer.internalActions.setMultipleBoxesEnabled(enabled));
        if (!enabled) {
            dispatch(uiReducer.callableActions.setActiveLayer(DEFAULT_LAYER));
            dispatch(uiReducer.callableActions.deselectBox());
        }
    };
};
/*
 * Save the layer being worked on — where its boxes stand and how they are
 * turned — to the user's library, to be laid out again on either layer in
 * other systems. Given the id of a saved layer, that one is overwritten (and
 * renamed) instead. Either way the layer remembers the saved layer, so saving
 * it again offers to overwrite that one.
 */
var savePalletLayout = function (name, overwriteId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var layer, data, _a, createLibraryItem, updateLibraryItem, savedId, result, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    layer = selectors.selectActiveLayer(getState());
                    data = selectors.selectActiveLayerPalletLayout(getState());
                    _a = userReducer.callableActions, createLibraryItem = _a.createLibraryItem, updateLibraryItem = _a.updateLibraryItem;
                    if (!overwriteId) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(updateLibraryItem({ id: overwriteId, name: name, data: data }))];
                case 1:
                    result = _b.sent();
                    if (updateLibraryItem.fulfilled.match(result))
                        savedId = result.payload.id;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(createLibraryItem({ kind: palletLayoutKind, name: name, data: data }))];
                case 3:
                    result = _b.sent();
                    if (createLibraryItem.fulfilled.match(result))
                        savedId = result.payload.id;
                    _b.label = 4;
                case 4:
                    if (savedId)
                        dispatch(sceneReducer.callableActions.setSavedPalletLayoutId({
                            layer: layer,
                            savedPalletLayoutId: savedId,
                        }));
                    return [2 /*return*/];
            }
        });
    }); };
};
/*
 * Lay a saved layer out on the layer being worked on, like a preset (one
 * undoable step, see `applyPalletLayout` in the scene reducer). A selected box
 * is let go of: the boxes it was picked among were just replaced.
 */
var applyPalletLayout = function (_a) {
    var id = _a.id, layout = _a.layout;
    return function (dispatch, getState) {
        dispatch(sceneReducer.internalActions.applyPalletLayout({
            layer: selectors.selectActiveLayer(getState()),
            layout: layout,
            savedPalletLayoutId: id,
        }));
        dispatch(uiReducer.callableActions.deselectBox());
    };
};
export var actions = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, sceneReducer.callableActions), systemDataReducerDefineParameters.callableActions), systemDataReducerSelectApplication.callableActions), systemPerformanceReducer.callableActions), uiReducer.callableActions), userReducer.callableActions), undoSnapshotsReducer.callableActions), { addGripPosition: addGripPosition, addCentralizedPump: addCentralizedPump, addTubeConnection: addTubeConnection, duplicateNode: duplicateNode, toggleCupFill: toggleCupFill, fillAreaWithGripPositions: fillAreaWithGripPositions, deleteNode: deleteNode, deleteNodes: deleteNodes, deleteEntities: deleteEntities, undo: undo, redo: redo, addEdges: addEdges, addEdge: addEdge, setUnitSystem: setUnitSystem, deleteEdge: deleteEdge, resetScene: resetScene, resetParametersToDefault: resetParametersToDefault, selectCup: selectCup, checklistActionSelectCup: checklistActionSelectCup, checklistActionAddPump: checklistActionAddPump, checklistActionAddTubeConnection: checklistActionAddTubeConnection, rehydrateSystemState: rehydrateSystemState, loadTemplateSystem: loadTemplateSystem, loadSystemState: loadSystemState, performAutoRouting: performAutoRouting, setParametersSelectApplication: setParametersSelectApplication, toggleGraphPanel: toggleGraphPanel, addCardboardBox: addCardboardBox, applyPalletPattern: applyPalletPattern, addSecondLayer: addSecondLayer, removeSecondLayer: removeSecondLayer, setMultipleBoxesEnabled: setMultipleBoxesEnabled, duplicateCardboardBox: sceneReducer.internalActions.duplicateCardboardBox, removeCardboardBox: sceneReducer.internalActions.removeCardboardBox, rotateCardboardBox: sceneReducer.internalActions.rotateCardboardBox, setCardboardBoxPosition: sceneReducer.internalActions.setCardboardBoxPosition, savePalletLayout: savePalletLayout, applyPalletLayout: applyPalletLayout });
